import React from 'react';

import { Skeleton } from '@mui/material';

import { titleStyle } from '@styles/common';

/** 파트너 계정: 조합 관리 > 상세 > 조합 실적 */
const PartnerGroupPerformanceSkeleton = () => {
  return (
    <>
      <div css={titleStyle}>조합 실적</div>
      <Skeleton
        variant="rectangular"
        height={440}
        sx={{
          borderRadius: '10px',
          boxShadow: '0px 0px 20px 0px rgba(206, 208, 214, 0.5)',
          marginBottom: '40px',
        }}
      />
    </>
  );
};

export default PartnerGroupPerformanceSkeleton;
